import {
    GET_ADMIN_PLATFORM_SETTNGS,
    GET_ADMIN_PLATFORM_SETTNGS_SUCCESS,
    GET_ADMIN_PLATFORM_SETTNGS_ERROR,
    UPDATE_ADMIN_PLATFORM_SETTNGS,
    UPDATE_ADMIN_PLATFORM_SETTNGS_SUCCESS,
    UPDATE_ADMIN_PLATFORM_SETTNGS_ERROR,
  } from "./actionTypes"
  
  export const getAdminPlatformSettings = (data) => {
    return {
      type: GET_ADMIN_PLATFORM_SETTNGS,
      payload: data
    }
  }
  
  export const getAdminPlatformSettingsSuccess = (platform_settings) => ({
    type: GET_ADMIN_PLATFORM_SETTNGS_SUCCESS,
    payload: platform_settings
  })
  
  export const getAdminPlatformSettingsError = (error) => ({
    type: GET_ADMIN_PLATFORM_SETTNGS_ERROR,
    payload: error
  })
  
  export const updateAdminPlatformSettings = (platform_settings) => {
    return {
      type: UPDATE_ADMIN_PLATFORM_SETTNGS,
      payload: platform_settings
    }
  }
  
  export const updateAdminPlatformSettingsSuccess = (platform_settings) => ({
    type: UPDATE_ADMIN_PLATFORM_SETTNGS_SUCCESS,
    payload: platform_settings
  })
  
  export const updateAdminPlatformSettingsError = (error) => ({
    type: UPDATE_ADMIN_PLATFORM_SETTNGS_ERROR,
    payload: error
  })
  